import Anketa from 'pages/Anketa/QuetionPage/Anketa';

export default Anketa;
